interface PaqWindow {
    _paq?: unknown[];
}

const ensurePaq = (): unknown[] | null => {
    if (typeof window === 'undefined') return null;
    const w = window as PaqWindow;
    if (!w._paq) w._paq = [];
    return w._paq ?? null;
};

export const MATOMO_GOAL_REGISTERED = 4;
export const MATOMO_GOAL_ORDERED = 5;
export const MATOMO_GOAL_NEWSLETTER = 6;

export const trackMatomoGoal = (goalId: number, revenue?: number): void => {
    const paq = ensurePaq();
    if (!paq) return;
    if (typeof revenue === 'number') {
        paq.push(['trackGoal', goalId, revenue]);
    } else {
        paq.push(['trackGoal', goalId]);
    }
};
